// Legacy severity codes - used for existing incidents
export const LegacySeverityItems = [
    { group: "NO_ERROR", value: "CircumstancesOrEvents", description: "Circumstances or events that have the capacity to cause error" },
    { group: "ERROR_INTERCEPTED", value: "ErrorDidNotReachPatient", description: "An error occurred but did not reach the patient. (An error of omission does reach the patient)" },
    { group: "ERROR_NO_HARM", value: "ErrorReachedPatientNoHarm", description: "An error occurred that reached the patient but did not cause patient harm" },
    { group: "ERROR_NO_HARM", value: "ErrorReachedPatientMonitoring", description: "An error occurred that reached the patient and required monitoring to confirm that it resulted in no harm to the patient and/or required intervention to preclude harm" },
    { group: "ERROR_HARM", value: "ErrorTemporaryHarm", description: "An error occurred that may have contributed to or resulted in temporary harm to the patient and required intervention" },
    { group: "ERROR_HARM", value: "ErrorTemporaryHarmHospitalization", description: "An error occurred that may have contributed to or resulted in temporary harm to the patient and required initial or prolonged hospitalization" },
    { group: "ERROR_HARM", value: "ErrorPermanentHarm", description: "An error occurred that may have contributed to or resulted in permanent patient harm" },
    { group: "ERROR_HARM", value: "ErrorInterventionToSustainLife", description: "An error occurred that required intervention to sustain life" },
    { group: "ERROR_DEATH", value: "ErrorPatientDeath", description: "An error occurred that may have contributed to or resulted in the patient's death" }
];

// New severity codes - Safety Event Classification (SEC)
export const NewSeverityItems = [
    // Serious Safety Event (SSE)
    { group: "SSE", value: "SSE1", description: "Death" },
    { group: "SSE", value: "SSE2", description: "Severe Permanent Harm" },
    { group: "SSE", value: "SSE3", description: "Moderate Permanent Harm" },
    { group: "SSE", value: "SSE4", description: "Severe Temporary Harm" },
    { group: "SSE", value: "SSE5", description: "Moderate Temporary Harm" },
    
    // Precursor Safety Event (PSE)
    { group: "PSE", value: "PSE1", description: "Minimal Permanent Harm" },
    { group: "PSE", value: "PSE2", description: "Minimal Temporary Harm" },
    { group: "PSE", value: "PSE3", description: "No Detectable Harm" },
    { group: "PSE", value: "PSE4", description: "No Harm" },
    
    // Near Miss Safety Event (NME)
    { group: "NME", value: "NME1", description: "Unplanned Catch" },
    { group: "NME", value: "NME2", description: "Last Strong Barrier Catch" },
    { group: "NME", value: "NME3", description: "Early Barrier Catch" }
];

// Combined items for display purposes
export const SeverityItems = [
    ...LegacySeverityItems,
    ...NewSeverityItems
];